module.exports = __webpack_public_path__ + "static/img/noPermission.74fb676a.svg";